var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"margin-bottom":"12px"},attrs:{"type":"primary"},on:{"click":_vm.handleAddGoods}},[_vm._v("选择赠品")]),_c('SpFinder',{ref:"finder",staticClass:"clear-finder-style",staticStyle:{"max-width":"1200px"},attrs:{"data":_vm.tableData,"setting":_vm.setting,"no-selection":"","show-pager":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }